export const BLOCK_IDS_BY_GAME: Record<string, string> = {
  '49lhLNd3Pe': '2419',
  '7CrtqYvqHj': '2421',
  '9uXwEffijy': '3519',
  '3P9d65nUHn': '3522',
  '8XcTJ6aPGr': '2411',
  '3qWEAiZ9B5': '6094',
  '36iOt5hfPr': '6095',
  '8NcrOj5AYI': '6100',
  '6yedrmVSFB': '6269',
  '93oTBiomJE': '4658',
  '9Qq0pR1b8c': '6638',
  '7sR4ivlzMu': '8744',
  '1j72ZmnFKQ': '8747',
  '6oyZgCwQNw': '8844',
  '7BeDwxUxp3': '8846',
  ijy06NIroR: '6096',
  zo2SZWGsKL: '6098',
  oKlJ0qCAOG: '6099',
  oMrjGov9gb: '6101',
  mUrERckVpc: '6102',
  Ig4LZ2XLWl: '6103',
  aqWNsDrTZl: '6104',
  xEXCGcDlTi: '6105',
  jbGsD9Vpez: '6106',
  LhSZWVYBsn: '6107',
  kH1oCoWRft: '6184',
  iqtxoc2V0d: '6270',
  k0BLSv6hy0: '1902',
  aCTcG4RcyN: '2408',
  TagNHeTpuJ: '2409',
  u8qGos6gn5: '2410',
  GJMPMky1fM: '2412',
  FixyoXu80U: '2413',
  AaMYWK8bYM: '2414',
  unz0SdDWlh: '2415',
  EDKN48Zy24: '2416',
  xaFhAlXKm6: '2417',
  mooRexrGxr: '2418',
  GGloytMRlN: '2420',
  GsS8BbgXbX: '2422',
  FOuMYegbJp: '2423',
  bVUX7WqlqV: '2424',
  zqkIAVtKAn: '2425',
  u2MWsDiJgJ: '2426',
  Hgyac7XKIj: '2427',
  aS2Uw79ieg: '2428',
  ycdCAG3w2v: '2429',
  NtDF2jZV4M: '2735',
  Oz4eGI64E8: '2736',
  Gqrp77ecpO: '2737',
  hUsO8XP3aV: '2738',
  f7BVRHtUd9: '2739',
  xBJmE1hXBa: '2740',
  JR2U0OS6QD: '2741',
  FUYZVKeMBy: '2742',
  tUpAM09ehL: '3520',
  h0quEhQidy: '3521',
  y2WVlyo0ja: '3523',
  lA10g2cucA: '3524',
  D1HHG3cdZ2: '4656',
  dD4wLlrGq0: '4657',
  L3ZI6MduV9: '4659',
  Ag21fvxkIh: '4698',
  mfisEahcLx: '6636',
  yS3O9FvmXI: '6635',
  TvP6zE6TPM: '6634',
  JYVEe5kXUO: '6637',
  YFrK8UCw5K: '6797',
  njAr4E6eDH: '6796',
  BLzaLCiD5E: '8732',
  OTz0QmLfGS: '8733',
  hUE4SNqsE4: '8734',
  vmV65tJbPo: '8735',
  i4j8MW8t4D: '8736',
  fXquHhqBA0: '8737',
  LWVXVZR5gY: '8738',
  FWHIK4bllm: '8739',
  VYJAUdjIMe: '8740',
  iHrK1tpoNf: '8741',
  EpUCryPpFD: '8742',
  tm62SNqr9F: '8743',
  Dg5FF3nOGL: '8745',
  ueuOGPRvDh: '8746',
  NoNoz2OVit: '8748',
  GVGmK2J6XH: '8845',
  jDCeOYpQ6V: '8952',
  C1MAET6ZvT: '8953',
  aWkN8yMshg: '8954',
  f7L1HP3VFR: '8955',
  '6FaW2i9Ber': '8956',
  '03O87LUjJk': '9791',
  REnau6pkGe: '9792',
  ScWIUgIXsU: '9793',
  '9QIbvNbmME': '9794',
  cPZu1hQqTn: '9795',
  rb2ff4rFMn: '9970',
  T9Wp1YjBoD: '9971',
  LDeFT9smj2: '9972',
  PrWti1Ir4X: '9973',
  yvEflIO4xi: '9974',
  RC0b0QPeut: '11137',
  EQFfxx0jNw: '11138',
  slMncifvlF: '11139',
  DJH7EhjmD4: '11140',
  hwN8vmGgQe: '11141',
  LE3WAng94t: '11142',
  qtczXNgK8l: '11143',
  WSmLmpgbFq: '11144',
  YDmkLGNlq: '11146',
  '0LXIhiPVkG': '11147',
  '0dYZCBa3GX': '11148',
  qu6RNG2iPh: '11149',
  cdnFjPIqWF: '11447',
  wMM6MZ4UOv: '11448',
  '6PnldekJqz': '11449',
  g2GT3p2P1j: '11450',
  OnwMnYyCoX: '11451',
  HH58yt79BO: '11452',
  gCmAQGYiqB: '11453',
  E4gXHWYjCJ: '13768',
  '1nuhTy3r22': '13769',
  XDc9C5rVvL: '13770',
  DyhVowenVG: '13771',
  '9rQp5TOidI': '13772',
  muPWaRl4pS: '13773',
  '539Lyv841S': '13774',
  TSz4DW9cYL: '13775',
  FOyOND3I4Z: '13776',
  Ey7NNoqMMJ: '13777',
  gaEh67e3wb: '13778',
  ezFYVmaUqW: '13779',
  ROAv3DfQkd: '13780',
  lHQDF4clqZ: '13781',
  HmaFKM3IiA: '13782',
  '9L3kAlbVhy': '13783',
  vWl8chvSHp: '13784',
  GTUgVnBpe9: '13785',
  '5lPfomkpOT': '13786',
  VcWFZO84Hc: '13787',
  yhQKs2wUay: '13788',
  hN3MH6qTSR: '13789',
  qoNUuylDEl: '13790',
  Wy2jbQGD8V: '13791',
  fEsUEMs3Ow: '13792',
  KViij0h8m7: '13793',
  Puq429Sxib: '13794',
  XPu2DXGLnH: '13795',
  c1rkl8QSpz: '13796',
  yR9v4kkvYV: '13797',
  ZKGLx3AgR1: '13798',
  BxYlnVOsAJ: '13799',
  mmQEdMST43: '13800',
  SLZx1tgMWt: '13801',
  yDo1sQL7v5: '13802',
  jUUsZsXkBQ: '13803',
  cn0OgVjMCw: '13804',
  eewm3fpSuY: '13805',
  PoB1HBBZtQ: '13806',
  hIbKvOmAX8: '13807',
  '9RHz0RFVH8': '13808',
  rmYNkMzoYW: '13809',
};
